import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const EcovestLoading = () => {
  const [progress, setProgress] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 100) {
          clearInterval(interval);
          // Redirect after a small delay to show 100% completion
          setTimeout(() => navigate('/Ecovest/Bowland'), 200);
          return 100;
        }
        return prevProgress + 1;
      });
    }, 20); // Update every 20ms for 2 seconds total (100*20ms = 2000ms)

    return () => clearInterval(interval);
  }, [navigate]);

  return (
    <div className="loading-container">
      <div className="loading-content">
        <img 
          src="/assets/images/ecovestwelcomeimg/tree.png" 
          alt="Ecovest Tree" 
          className="loading-image"
        />
        <div className="progress-bar-container">
          <div 
            className="progress-bar" 
            style={{ width: `${progress}%` }}
          ></div>
        </div>
        <p className="loading-text">We’re setting up your space...</p>
      </div>
    </div>
  );
};

export default EcovestLoading;